import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DialogModule } from 'primeng/dialog';

import { PipesModule } from '../../pipes/pipes.module';

/**
 *
   * @input pdfUrl - The first input number
   * @input isVisible - The second input number
   * 
   * @usage
   * <via-pdf-viewer
      pdfUrl="https://vadimdez.github.io/ng2-pdf-viewer/assets/pdf-test.pdf"
      [isVisible]="pdfVisible"
    ></via-pdf-viewer>
   *
   */
@Component({
  selector: 'via-pdf-viewer',
  standalone: true,
  imports: [CommonModule, DialogModule, PipesModule],
  templateUrl: './pdf-viewer.component.html',
})
export class OPdfViewerComponent {
  @Input() pdfUrl = '';
  @Input() isVisible = false;

  @Output() toggle = new EventEmitter();

  toggleModal() {
    this.toggle.emit();
  }
}
